import Form, {
  formCreate,
} from '@/found/components/form';
import request from '@/found/utils/request';
import detailList from './form.vue';

formCreate.component('detailList', detailList);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
      formFunctionCode: 'main_form',
    };
  },

  methods: {
    setRule(v) {
      const item = v;
      if (item.field === 'detailList') {
        item.props = {
          ...item.props,
          participatorCode: this.formConfig.row.participatorCode,
        };
      }
      return item;
    },
    // 提交
    submit() {
      this.$emit('onClose');
    },
  },
};
